<template>
  <div class="dhmap-wrapper">
    <map-selector ref="mapselector" :param="param" mode='h5'></map-selector>
  </div>
</template>

<script>
import mapSelector from "@/components/map/MapSelector"
export default {
  name: "selector",
  components: {mapSelector},
  props: {},
  data() {
    return {
      param:{}
    }
  },
  mounted(){
    window.getPosition = this.getPosition
    this.param.basemap = 'all'
    if(this.$route.query.zrqlx && this.$route.query.zrqobjid){
      this.param.zrqlx = this.$route.query.zrqlx
      this.param.zrqobjid = this.$route.query.zrqobjid
    }
    if(this.$route.query.lon && this.$route.query.lat){
      this.param.lon = this.$route.query.lon
      this.param.lat = this.$route.query.lat
    }
  },
  methods:{
    getPosition(){
      return this.$refs.mapselector.getPosition()
    }
  },
  computed:{
      
  }
}
</script>

<style scoped>
.dhmap-wrapper{
  width:100%;
  height: 100%;
}
</style>